import React from "react";
import Marquee from "../components/Marquee";
import { Hero, Catalogue } from "../components/HeroCatalogue";
import { OrderSection, Manifesto, Reviews, Payments } from "../components/Sections";
import { BundleRitual, LipDuo, BrandStory } from "../components/BundleBrand";

const Home = () => {
  return (
    <main>
      <Hero />
      <Marquee />
      <Catalogue />
      <BundleRitual />
      <LipDuo />
      <BrandStory />
      <OrderSection />
      <Manifesto />
      <Reviews />
      <Payments />
    </main>
  );
};

export default Home;
